function ListingIdNotFound() {
  this.status = 404;
  this.message = 'listing id not found';
}

function removeQueryFromPath(listingName) {
  return listingName.split('?')[0];
}

export const extractListingId = (listingPath) => {
  const listingName = removeQueryFromPath(listingPath);
  const regex = /([\d]+)$/;
  const matchResult = listingName.match(regex);
  if (matchResult) {
    return matchResult.pop();
  }
  throw new ListingIdNotFound(listingName);
};
